import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import SignIn from "./pages/Auth/SignIn/SignIn";
import SignUp from "./pages/Auth/SignUp/SignUp";

import { Toaster } from "react-hot-toast";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useEffect } from "react";

import ScrollToTop from "./components/common/ScrollToTop";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import AdminGuard from "./components/common/AdminGuard";
import CreateProduct from "./container/Product/CreateProduct";
import UpdateProduct from "./container/Product/UpdateProduct";
import Admin from "./components/admin/Admin";
import Products from "./container/Product/Products";
import ProductDetails from "./container/Product/ProductDetails";
import Cart from "./container/Product/Cart";
import Search from "./components/search/Search";
import Profile from "./pages/Profile/Profile";
import FeaturedProducts from "./container/Product/FeaturedProducts";
import HomeSkeleton from "./components/common/HomeSkeleton";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import OrderDetail from "./container/Product/OrderDetail";
import AdminOrderDetails from "./components/admin/AdminOrderDetails";
import AllAdminOrders from "./components/admin/AllAdminOrders";
import FilteredProducts from "./pages/filter/FilteredProducts";
import WishList from "./container/Product/WishList";
import TrackOrder from "./components/common/TrackOrder";
import AdminCreateHero from "./components/admin/AdminCreateHero";
import EditHero from "./components/admin/EditHero";

import { CartProvider } from "./hooks/CartContext";
import { WishProvider } from "./hooks/WishContext";
import ForgotPassword from "./pages/Profile/ForgotPassword";
import ResetPassword from "./container/settings/ForgottenPassword";
import PaymentMethod from "./container/Product/PaymentMethod";
import Customer from "./pages/Customer";
import { Fa0 } from "react-icons/fa6";
import FAQSection from "./pages/FAQ";
import ProductCategoryPage from "./container/Product/ProductCategoryPage";

function App() {
  const location = useLocation();

  const hideBars = ["/signin", "/signup"].includes(location.pathname);
  const API_URL = process.env.REACT_APP_API_URL;

  const { data: authUser, isLoading } = useQuery({
    queryKey: ["auth"],
    queryFn: async () => {
      const token = Cookies.get("gameport");
      if (!token) return null;

      const res = await fetch(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (!res.ok) return null;
      return data; // whatever your backend returns for /auth/me
    },
    retry: false,
  });

  useEffect(() => {}, [authUser]);

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <HomeSkeleton />
      </div>
    );
  }

  return (
    <CartProvider>
      <WishProvider>
        <div className="min-h-screen flex flex-col justify-between text-black">
          <ScrollToTop />

          {!hideBars && <Navbar />}

          <div className="p-1 flex-1">
            <Routes>
              {/* Admin */}
              <Route
                path="/admin"
                element={
                  <AdminGuard>
                    <Admin />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/create-product"
                element={
                  <AdminGuard>
                    <CreateProduct />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/update-product/:id"
                element={
                  <AdminGuard>
                    <UpdateProduct />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/create-hero"
                element={
                  <AdminGuard>
                    <AdminCreateHero />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/hero/edit/:id"
                element={
                  <AdminGuard>
                    <EditHero />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/orders/:id"
                element={
                  <AdminGuard>
                    <AdminOrderDetails />
                  </AdminGuard>
                }
              />
              <Route
                path="/all-orders"
                element={
                  <AdminGuard>
                    <AllAdminOrders />
                  </AdminGuard>
                }

              />
              <Route
                path="/customers"
                element={
                  <AdminGuard>
                    <Customer />
                  </AdminGuard>
                }
                
              />

              {/* Auth */}
              <Route
                path="/signin"
                element={authUser ? <Navigate to="/" replace /> : <SignIn />}
              />
              <Route
                path="/signup"
                element={authUser ? <Navigate to="/" replace /> : <SignUp />}
              />

              {/* Pages */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              <Route path="/featured" element={<FeaturedProducts />} />
              <Route path="/consoles" element={<Products />} />
              <Route path="/shop-consoles" element={<Products />} />
              <Route path="/filter" element={<FilteredProducts />} />

              <Route path="/product/:id" element={<ProductDetails />} />
              <Route path="/search/:query" element={<Search />} />
<Route path="/product-category/:categoryName" element={<ProductCategoryPage />} />
              <Route path="/shopping-cart" element={<Cart />} />
              <Route path="/cart" element={<Cart />} />

              <Route path="/order/:id" element={<OrderDetail />} />
              <Route path="/track-order" element={<TrackOrder />} />

              <Route path="/my-account" element={<Profile />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/wishList" element={<WishList />} />

              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout/payment" element={<PaymentMethod />} />
              <Route path="/about" element={<About />} />
              <Route path="/faqs" element={<FAQSection />} />

              {/* fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>

          {!hideBars && <Footer />}
          <Toaster />
        </div>
      </WishProvider>
    </CartProvider>
  );
}

export default App;
